module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-3"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "x1chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#chapter-3"
    }
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-first",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "initial-caps"
  }, [_vm._v("T")]), _vm._v("he day consisted of dressmaking frippery that even Mrs. Austen joined, abandoning her garden and scrubbing her nails clean, and even going so far as to retrim her best turban with some feathers that had once graced one of Cassandra’s bonnets. Jane, meanwhile, retreated to her table in the dining room and glared ferociously at anyone who might dare disturb her.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Don’t growl at me!” Cassandra said. “I wanted to tell you only that I had borrowed a pair of your silk stockings.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Her hand over her mouth, Jane nodded. Her canines ached and stung, and she wanted to rise and pace around the room. Outside, the sun had passed its brightest and highest point of the day, and in a few hours it would be dark.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You had best get ready,” Cassandra said. “We expect the carriage in twenty minutes, and your hands are covered with ink. How did those papers get in such a state with all those horrid stains?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You don’t remember?” Jane said.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“They look as though they’re fit only to start a fire.” She reached a hand out.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“No!” Jane said. “That is—see, I twist each into a spill when I have finished with it.” She looked at Cassandra’s placid, pretty face and wondered how long it would be before her sister’s composure was destroyed.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Do you not remember, Cassandra? I killed a man in front of you, ripped out his throat before he could shoot you, and you lay on the floor among these bloody papers and screamed and shrank from me, because you saw me as a monster. No wonder you wished to forget. Who would want to see their own sister so?")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("But instead of saying the words, she gathered her papers into a neat pile and pressed them into the storage area of the writing slope. She kissed her sister’s cheek, catching a brief hint of her scent and of her excitement at the thought of an evening out.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Cassandra, if I said that we should absolutely not go to the Great House but I could not give you a reason why, would you abide by my wishes?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Cassandra laughed. “When I remember the young Miss Jane who was such a determined flirt and whose only aim in life was to shock our neighbors, I’m surprised that you take such a high moral stance with Anna. Have you forgotten what it is to be young?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“It’s not about Anna,” said Jane. “Not as much as it is about them, Edward’s tenants. I do not think we should consort with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, don’t be foolish,” Cassandra said. “Doubtless they intend to invite us once, and then, their duty to our brother done, they will ignore us for as long as they stay here. I doubt whether they will stay more than a month or so, for we are so very quiet here.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“What do you remember of Mr. Fitzpatrick?” Jane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Cassandra took her arm and led her out of the dining room and up the stairs. “He was a very pleasant gentleman as I remember. He helped us find temporary lodgings when—when—” Her voice faltered.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“When the French wanted to arrest you and Mama and Papa, having arrested me.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Jane!” Cassandra pushed her into their bedchamber. “We should not talk of that time. We agreed not to, do you not remember? It was a very unhappy time for us, and you were unwell, and . . . I shall unlace your gown so you can put on your best one, and you should really wash your face. You have a smudge of ink here.” She licked her fingertip and rubbed a spot on Jane’s cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Oh, poor Cassandra. She was so frightened of letting loose a great flood of awful memories and unanswered questions. Jane embraced her, and Cassandra gave a squeak of surprise. “What was that for?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, I merely felt like expressing my affection for my dearest sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You squeezed me half to death!” Cassandra said, releasing herself. “Come along, you silly sentimental creature, you must hurry.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("After a little sisterly bickering—Cassandra had borrowed the pair of silk stockings that Jane herself had intended to wear, claiming that the other pair were finer, although Jane pointed out that they were held together by a cobweb of darns—the sisters descended the stairs. Mrs. Austen, majestic in her refurbished turban, stood with Anna, who was quite pale with nervousness.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Will it be so very grand?” Anna asked.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Of course not,” Jane said. “This is the country.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-after-txb1",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "initial-caps"
  }, [_vm._v("S")]), _vm._v("he was wrong. The house was ablaze with lights, something that caused the thrifty Mrs. Austen to gasp and speculate aloud how much the household must spend a year on wax candles. Footmen, all of them young and handsome—why was Jane not surprised?—were everywhere, and she hoped she and Cassandra between them could come up with a respectable amount of pennies for vails. These footmen, however, looked as if anything below a shilling apiece was beneath their notice.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Dorcas moved forward to greet them as the Austens were shown into what had once been the Great Hall of the house several centuries before, where about a dozen people were gathered.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Why, Jane, you sly thing! You quite outdo me in taste and elegance.” Dorcas, whose luxurious, flowing gown was the height of fashion along with the silver and paste comb in her hair, linked her arm in Jane’s.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You flatter me,” Jane said.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Nonsense! Such elegance of figure and face—yes, you are one of us, it is clear to all now. Come, you must see William. I assure you he has been in such a state, anticipating your reunion.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Indeed? And what sort of state would that be?” Jane cast a glance over her shoulder. She was relieved to see her mother, sister, and niece talking to Mr. Papillon, the curate, and his sister, but as she was led across the room, a wake of whispers followed, as her neighbors speculated upon Miss Jane Austen and her handsome friend. Had she been a good ten years younger and the comments related to her looks and gown, she would have been mightily flattered. Now, she was alarmed to be associated with Dorcas.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I think my mother may need me,” she managed feebly.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Good heavens, no, she is deep in the subject of herbaceous borders with her neighbors.” Dorcas led her back into the entrance hall and past the Jacobean staircase. A footman sprang forward to open a door into a small book-lined room.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane took a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“My dear Jane.” William stepped forward and took her hands, and thirteen years of pain and longing dropped away.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He looked the same; of course he would, and he would do so for centuries more, tall and dark haired, handsome. He regarded her gravely.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You need not tell me I am changed,” she said. “Consider that I am older and wiser.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You are still the most handsome woman of my acquaintance,” William said.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane considered shrieking and slapping him with her fan—the Misses Steeles, recent literary inventions whom she was enjoying immensely, would almost certainly have done so. But instead she basked in his warmth and welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I was most sorry to hear of Mr. Austen’s death,” William said.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I miss him still.” She withdrew her hands. “What do you want, William? You are behaving almost as—as any normal gentleman might, yet I know you for what you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“So you should. I am your Creator.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“A pity you did not say so with such ardor thirteen years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“It was a—a difficult time.” He spread his hands in supplication. “Can you forgive me for my callousness and neglect?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane walked away from him and took a turn of the room, noting the ancient mullioned windows and tapestries, faded with age, that adorned the walls. The planks beneath her feet were wide and glowed with the patina of centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("She turned back to him. “Sir, you created and abandoned me, breaking the rules of your own kind—and pray do not bleat of difficult times, for you sound like my sister and mother at their most peevish. No one will speak of what is past. Yet it is done and we live with the consequences, I with my decision to become mortal again, and you—”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You? Mortal?” He moved to her side, fast and graceful. “I think not, Jane.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("She glared at him. “Oh, very well. At the moment I am neither fish nor fowl.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He reached out to her again, but she evaded his hand. “Over a decade, William, I have wandered, unable to settle because of family circumstances. Now and again I would take out my manuscripts and look at them, yet I could not bear to return to what had given me so much joy. I was afraid that I had lost everything, that my small gift as a writer had faded. And now, now when we are settled and my mother and sister have as much happiness as women in their situation can expect, I have started to work once more, and it is the greatest delight of my life. Shall it be taken from me again, William?” She stamped her foot like a younger Anna in a rage. “It is so damned unfair!”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I will atone,” he said. “I swear it.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("She snorted. “Oh, certainly. You sound like someone in an Italian opera. Or in a book—a bad one. Some gothic horror with an ancient house and mysterious creatures dwelling therein.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He smiled. “Life imitates art, my dear Jane.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“It depends entirely upon your definition of life, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Still as witty and as passionate as ever, Jane. Jane, let me be your Bearleader. Let me guide you through this maze. I abandoned you the first time. I will not do so a second time.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("She had forgotten his power over her, the seductive thrill of his voice and person, but he had failed her before.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Enough of your high-flown eloquence, William. Now tell me what you want from me.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He walked past her to the window and leaned his forehead on the glass. “In a matter of hours it will be dark, and every night I hope . . . Jane, you are the last of my fledglings. Do not leave me.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("A long silence. The timbers of the ancient house made small sounds as it settled with the fading warmth of the day, and a shower of sparks arose as a log shifted in the fireplace.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Luke?” Jane said, her voice tight and the sadness that she had worked so hard to conquer rising in her. “What has happened to Luke?” Her former lover was old, for one of the Damned, almost as old as William, his Creator. He might well be gone to dust and to the fires of hell.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“He lives still,” William said. “But he is—he left to join another household. There is a rift between us.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I am sorry to hear it,” Jane said.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“And as for George, well, he is the Prince of Wales and his memory is short. He is ungrateful and intemperate. He has thrown us over entirely, Jane, as a child throws away the toys he has tired of.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“So I have heard.” She smiled, but she was anxious not to talk of Luke. “And so that is why you try so hard to be country gentry.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He gave a rueful laugh and turned from the window. “And how do we do?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Quite badly, I fear. You really must do something about the horses, you know. People like them in the country, and dogs, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He grimaced. “We have some dogs for appearances’ sake. They hate us. Quite often I’m tempted to bite them back. ”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Most unfortunate,” Jane said, relieved that they no longer spoke of Luke. “But why? Why do you go against your nature so?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“We are out of fashion,” William said. “It has happened before and it will happen again. We have found it wisest to lie low, to practice discretion in our ways. It is how we survive. We shall wait a century or so and see how taste and fashions change, and when the time is right, we shall take our rightful place in society once more. Consider, for example, that once we could not go out in the daytime; we have changed over the centuries.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I must say I was astonished to meet one of the Damned fully dressed—although very badly—at ten of the morning, when Dorcas came to call,” Jane said.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“She told me of it. Join us, Jane. It is time.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("She shook her head. “No, William. I cannot. I shall pray, for myself and for you, but I will not hurt my family.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He strolled to the fireplace and kicked the logs into a blaze. “At the least, be good neighbors to us, Jane, for I must care for my family, too, this household. And I shall help you, for I see a metamorphosis has begun in you. So it is with those who take the waters as Cure; often it is not complete. Have you been "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("en sanglant")]), _vm._v(" yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“No, but my teeth ache. Of course, at my advanced age that is to be expected, but this is different. Of late I have been able to feel things and hear others’ thoughts. I hate it, William. I should rather do anything than become one of the Damned again.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“And—this is indelicate, forgive me—you feel no urge to dine?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I should quite like some dinner, William, but I know that is not what you mean. No. Not yet, but I fear I shall hunger.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You must come to me when it happens. Promise me.” He held out his hand to her. “I shall help.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("She took his hand and allowed herself to be lulled into the web of warmth and safety and, yes, love that he spun around her. But it was not enough, and it was not what she wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You know I shall never leave Cassandra again,” she said. “I value my soul, sir, and I value my small gift for writing. I shall fight with prayer and all human means to preserve myself. But if my metamorphosis continues, I wish to know what I may expect.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He bowed his head in acknowledgment. “I admit we chart unknown waters. I cannot tell you how long it will take the metamorphosis to take place or what human qualities you will lose.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“If I were able to write still . . .” She looked away, horrified. Was her soul of so little concern that she should place her writing above everything?")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He shook his head. “I wish I could set your mind at ease.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("For a moment she almost pitied him, her once-powerful Creator admitting that even despite his centuries of existence, his knowledge was limited.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Do we dine?” she said. “I mean—that is, maybe it is time we should go into dinner. I trust you do not have designs upon your neighbors’ persons.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Ah. Once . . .” William smiled. “But no, those days are past. We are entirely respectable now. But it is time for me to play host, and we shall join the others.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He offered his arm to escort her.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Then how do you . . . I trust I am not indelicate, but I hardly think you have developed a taste for good English beef. I could not help but notice your footmen.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He cleared his throat. “Indeed.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“How very convenient that there are so many and all so handsome,” Jane commented as they entered the Great Hall again.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“And a few adventurous ladies find reasons to call. They are most welcome.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Indeed! Now I shall wonder who among my acquaintance succumbs to the charms of your company. But you do not need to tell me, William; I shall find them out. I have an eye for an adulteress.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-after-txb1",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "initial-caps"
  }, [_vm._v("J")]), _vm._v("ane enjoyed dinner, as much for the food and wine as for watching the Damned, William, and his alleged sister-in-law Dorcas and her brother Tom (the blood tie that bound them was not a human one and they might even be lovers or bound as Consorts according to the customs of the Damned). Their deception and appearance were innocent; they ate little and encouraged their guests to talk of country matters, crops and the weather, gossip of neighbors and their activities.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Anna, she was pleased to see, looked exceedingly pretty and, although shy, responded readily when those seated close to her engaged her in conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("After dinner, Dorcas led her female guests upstairs to the parlor, where one of the handsome footmen assisted in pouring and handing out tea.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“How very polite we—you—have become,” Jane said to her in a low voice, thinking of the activities in which the Damned indulged when she had last been among them.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Dorcas sighed. “I know. It is so very tedious. But tell me, Miss Jane”—in a slightly louder voice—“how long does your charming niece stay with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“A month or so,” Jane replied. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lay one finger, or one tooth upon her, you or any of your kind, and I shall rip out your throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I am most saddened you trust us so little,” Dorcas replied quietly. “But do you not see? It is your true nature as one of the Damned that makes you so very protective of your family.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You are mistaken, ma’am. My family has always been my first loyalty.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("A flicker of canine appeared at Dorcas’s lip. “William is of your family. By extension, so am I and Tom. We shall stand by you, whatever you feel, although your ingratitude pains me.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane bowed her head. She declined an invitation to perform at the pianoforte, a handsome instrument she envied, but encouraged Anna to do so, and was gratified at the warm applause that met the young woman’s playing.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Charming, quite charming,” Tom announced, as he and William entered the drawing room. “You play exceedingly well, Miss Anna. Do you sing, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Anna gazed at Tom with obvious admiration, making no effort to hide her attraction, and a small triumphant smile played over Tom’s beautiful lips.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane clapped a hand to her mouth as pain surged through her canines. Horrified, she fought to regain control. William gave her a concerned look.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Why, what is the matter, Jane?” Mrs. Austen asked.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Toothache,” Jane muttered from behind her hand. “Do not concern yourself, ma’am.” Sure enough, her canines were aching and sensitive and sharp to her tongue. She was not quite "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("en sanglant,")]), _vm._v(" but it was the nearest she had come so far.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“We really must take you to the dentist if things do not improve,” Mrs. Austen said. “What do you think, Martha?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Dear Jane, allow me to look,” Martha said, and touched Jane’s hand with her own. They both wore lace mittens, and the effect of bare skin touching her own was too much. Martha’s anxiety flooded her mind, overwhelmed her.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane leaped to her feet. “I beg of you—”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Jane, you must drink this.” William was at her side, a small glass of wine in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("A drop of something dark coiled and spread in the wine, dissipating like smoke and releasing a rich scent. She reached for the glass and its precious liquid, a single drop of William’s blood dissolved in wine, the first time he had ever allowed her this great privilege. A great sense of well-being and safety spread through her as she drank her Creator’s gift.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“So. Do you feel better?” William took the glass from her and placed it on a tray held by a footman who lingered nearby. Jane suspected, from the gleam in his eye, that the footman might take the glass away and scoop out any last drops for himself.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Much better, thank you.” Her teeth were once more under control, and her anxiety and rage had ebbed away, leaving peace and happiness in their wake.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Let us repair to the Great Gallery, ladies!” Dorcas moved forward to take William’s arm. “I believe I can hear our musicians tuning their instruments.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Cassandra joined Jane as the ladies, gathering shawls and fans, prepared to follow their hosts. “Fie on you, flirting so!” She giggled.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“But he is so very handsome,” Anna whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Nonsense. We are old friends, William and I, and he most kindly gave me some wine. You have such an imagination, sister. Maybe you should write a book.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Cassandra stuck her tongue out at Jane in a most unladylike way while Anna looked on in amazement.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, behave yourselves,” Martha said. “May I help you with your shawl, Mrs. Austen?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Thank you, my dear. I fear my daughters are neglectful of me, so determined are they to behave like children, although I must say as young girls you two were much better behaved.” But Mrs. Austen smiled as she spoke. “I was not aware you knew Mr. Fitzpatrick so intimately, Jane. I can scarcely remember you speaking to him when we met him in Bath. But there was another gentleman, was there not? I fancied you harbored a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tendresse ")]), _vm._v("for—”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Ma’am, how can I set an example to my niece if you insist on revealing my scandalous past?” Jane took her mother’s arm. “Anna, if you are to learn anything of this, it is not to overindulge in a host’s excellent wine at dinner. I fear Martha may be busy making draughts for our aching heads tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Indeed, yes, and they will taste exceedingly unpleasant!” Martha smiled. “Will you dance, Jane?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Of course not. I have had enough dissipation for the evening. I intend to sit by the fire and make tomorrow’s medicine worthwhile with some more wine. But I hope Anna will dance every dance.” As she spoke she guided her family toward the fireplace in the long room running the length of the house, where once ladies in outlandish ruffs and farthingales had taken their exercise. A group of musicians, whom Jane recognized as the village waits who played at Christmas and on other festive occasions, struck up a lively tune.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("William approached the Austens and bowed. “Jane, you’ll dance with me, I hope. And Mr. Fuller would very much like to be introduced to Miss Anna for the first dance.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane, aware that but a few minutes ago Tom Fuller’s interest in her niece enraged her, smiled as the introductions were made and rested her hand in William’s. Other couples joined them, but before the dance could begin, a footman made his way to William’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Sir, I beg your pardon, but the others, you know, sir, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("they")]), _vm._v(" are here, and . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Pray excuse me, ma’am.” William bowed to Jane and drew the servant aside. The man seemed to be in some state of consternation.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Very well,” William said to him after a short exchange. “Show them in.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("But already a group of newcomers had arrived in the Gallery, half a dozen members of the Damned.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane gasped as pain shot through her teeth once more.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("William came back to her side. “I regret I must leave you to talk with my new guests. I shall claim another dance this evening, Jane. Is everything well with you?” He added in a lower voice.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Well enough.” She took her place on the couch next to Cassandra.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Cassandra squeezed her hand. “Never mind, I am sure you will dance again. Who are those people? The red-haired lady and the gentleman with her look very familiar.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, yes,” Jane said. “Most familiar indeed.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-242fa88b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_3.vue
// module id = 75
// module chunks = 0